import { loanInfoCardsWrapperBaseStyles } from '@sharedCR/loanSummary/LoanInfoCards';

import { mediaQuery, RESPONSIVE_PADDING } from 'constants/ui';

const GRID_COLUMNS_MD = 4;
const GRID_COLUMNS_TABLET = 3;

const getFadeGradient = direction =>
  `linear-gradient(to ${direction}, #FFFFFF 0%, rgba(255, 255, 255, 0.9) 10%, rgba(255, 255, 255, 0) 100%)`;

export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  padding: {
    xs: RESPONSIVE_PADDING.MOBILE,
    sm: RESPONSIVE_PADDING.DESKTOP,
  },
  backgroundColor: ({ palette }) => palette.background.paper,
  borderRadius: '8px',
  boxShadow: ({ palette }) => palette.shadow.m,
};

export const tabsWrapperStyles = {
  position: 'relative',
  display: 'flex',
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const getSummaryWrapperStyles = length => ({
  ...loanInfoCardsWrapperBaseStyles,
  gridTemplateColumns: `repeat(${Math.min(length, GRID_COLUMNS_MD)}, 1fr)`,

  [mediaQuery.mobile]: {
    gridTemplateColumns: '1fr',
  },

  [mediaQuery.tablet]: {
    gridTemplateColumns: `repeat(${Math.min(length, GRID_COLUMNS_TABLET)}, 1fr)`,
  },
});

export const summaryCardStyles = {
  padding: '4px 8px',
};

export const tabStyles = {
  minHeight: 'unset',
  minWidth: 'unset',
  maxWidth: 'unset',
  padding: '16px 24px',
  color: ({ palette }) => `${palette.text.secondary} !important`,
  textTransform: 'none',
  textDecoration: 'none !important',
  opacity: 1,

  '& .hidden-label': {
    height: 0,
    visibility: 'hidden',
    fontWeight: 700,
  },

  '&[aria-selected="true"]': {
    color: ({ palette }) => `${palette.text.primary} !important`,

    '& .label': {
      fontWeight: 700,
    },
  },
};

export const tabLabelWrapper = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const tabLabelStyles = {
  fontSize: '1.6rem',
  lineHeight: '1.9rem',
};

export const scrollButtonStyles = {
  position: 'absolute',
  width: 'fit-content',
  height: '100%',
  opacity: 1,
  zIndex: 1,

  '&:after': {
    position: 'absolute',
    content: '""',
    width: '20px',
    top: 0,
    bottom: 0,
    pointerEvents: 'none',
    zIndex: 2,
  },

  '&:first-of-type': {
    left: '-20px',

    '&:after': {
      right: '-20px',
      background: getFadeGradient('right'),
    },
  },

  '&:last-of-type': {
    right: '-20px',

    '&:after': {
      left: '-20px',
      background: getFadeGradient('left'),
    },
  },
};

export const tabsSkeletonsWrapperStyles = {
  display: 'flex',
  gap: '48px',
  padding: '16px 24px',
};
